import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'add_ons_detail_page' */ './AddOnsDetailPage'),
);
